import { callNative } from '@/utils/bridge'

/** 获取设备id */
export function getDeviceId() {
  return callNative('getDeviceId')
}

/** 获取SDK登录参数 */
export function getSDKParam() {
  return callNative('getSDKParam')
}

/**
 * 退出SDK
 * @param param - 退出的参数
 * @returns
 */
export function exitSDK(params) {
  console.log('[退出SDK]')

  params = params
    ? params
    : {
        tradeStatus: 6001,
        msg: '用戶中途取消',
      }

  return callNative('exitSDK', params)
}

/**
 * 完成支付
 * @param params
 * @returns
 */
export function finishOrderPay(params) {
  sessionStorage.clear()
  console.log('[finishOrderPay called]')
  return callNative('finishOrderPay', params)
}

// 隐藏APP Navbar
export function hideNavigationBarSync() {
  return callNative('hideNavigationbarSync')
}

// 显示APP Navbar
export function showNavigationBarSync() {
  return callNative('showNavigationbarSync')
}

// 设置APP Navbar Title
export function setNavigationBarTitleSync(title = '') {
  return callNative('setNavigationbarTitleSync', title)
}

// 隐藏APP Navbar
export function hideTopBarWithStatusMarginSync() {
  return callNative('hideTopBarWithStatusMarginSync')
}

// 开启 Navbar
export function showTopBarWithStatusMarginSync() {
  return callNative('showTopBarWithStatusMarginSync')
}

//  IOS 禁用弹性滚动
export function setWebViewBouncesDisable() {
  return callNative('setWebViewBouncesDisable')
}

// IOS 开启弹性滚动
export function setWebViewBouncesEnable() {
  return callNative('setWebViewBouncesEnable')
}

export default {
  finishOrderPay,
  getSDKParam,
}
